import Service, { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import config from 'cio/config/environment';
import FeaturesService from 'ember-feature-flags/services/features';

export interface HydraProps {
  rootUrl?: string;
  scrollContainerSelector?: string;
  useNewWorkspacesUrls?: boolean;
}

const DEFAULT_PROPS = Object.freeze({
  useNewWorkspacesUrls: false,
});

export interface HydraWorkspace {
  id: number;
  account_id: number;
  cio_workspace_id: number;
  cdp_workspace_id: number;
  cio_initialized: boolean;
  cdp_initialized: boolean;
  name: string;
  color: string;
  cio_workspace_meta: {
    object_types: { id: number; name: string; slug: string; colour: string; icon: string }[];
  };
}

export default class HydraService extends Service {
  @service features!: FeaturesService;

  config: HydraProps | null = { ...DEFAULT_PROPS };

  constructor() {
    super(...arguments);

    // @ts-ignore - owner not typed correctly
    let hydraProps = getOwner(this).application.hydraProps ?? null;

    if (hydraProps != null) {
      this.config = { ...DEFAULT_PROPS, ...hydraProps };
      // Ideally, we should access the props/config via this service, but this
      // is not always possible. Most notably, when defining routes, we don't
      // have access to services. In order to still be able to conditionally
      // change the route structure, we set the props on the main env config as
      // well.
      config.hydraProps = this.config;
    }
  }

  get isHydraEnabled() {
    return config.isHydraMode ?? false;
  }

  get useHydraTopNav() {
    return this.isHydraEnabled && this.hydraTopNavPortal != null;
  }

  get hydraTopNavPortal() {
    return document.querySelector('#hydra-top-nav-portal');
  }

  get useNewWorkspacesUrls() {
    return this.isHydraEnabled && (this.config?.useNewWorkspacesUrls ?? false);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    hydra: HydraService;
  }
}
